import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const CustomSelect = (props: WidgetProps) => {
  const { id, schema, options, value, required, disabled, readonly, label, onChange } = props;

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id={`${id}-label`}>{label || schema.title}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        label={label || schema.title}
        disabled={disabled || readonly}
        required={required}
      >
        {(options.enumOptions || []).map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
